import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import {
  LayerControlContainer,
  LayerControlLabel,
  LayerControlListContainer,
  LayerControlListElement
} from './styles';

const LayerControl = ({ layers, layersOverlayed, show, title, selectLayer }) => (
  <LayerControlContainer className="alert alert-light" show={show}>
    <LayerControlLabel className="alert-heading">{title}</LayerControlLabel>
    <LayerControlListContainer>
      {map(layers, ({ _id, name }, index) => {
        return (
          <LayerControlListElement key={_id}>
            <label htmlFor={_id}>
              <div className="leaflet-control-div">
                {name}
                <input
                  type={layersOverlayed ? 'checkbox' : 'radio'}
                  className="leaflet-control-layers-selector"
                  defaultChecked={layersOverlayed || index === 0}
                  id={_id}
                  name={layersOverlayed ? name : 'activeLayer'}
                  style={{ opacity: 0 }}
                  onChange={selectLayer}
                />
                <span className={`leaflet-control-span${layersOverlayed ? 'Overlay' : ''}`} />
              </div>
            </label>
          </LayerControlListElement>
        );
      })}
    </LayerControlListContainer>
  </LayerControlContainer>
);

LayerControl.propTypes = {
  layers: PropTypes.array.isRequired,
  layersOverlayed: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  selectLayer: PropTypes.func.isRequired
};

export default LayerControl;
